import { GetterTree } from 'vuex'
import { ListsState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<ListsState, RootState> = {
    templatesStatusList:state => state.templatesStatusList,
    messagesStatusList:state => state.messagesStatusList,
    smsMessagesStatusList: state => state.smsMessagesStatusList,
    callMessagesStatusList: state => state.callMessagesStatusList,
    pushMessagesStatusList: state => state.pushMessagesStatusList,
    emailMessagesStatusList: state => state.emailMessagesStatusList,
    viberMessagesStatusList: state => state.viberMessagesStatusList,
    whatsappMessagesStatusList: state => state.whatsappMessagesStatusList,
    customMessagesStatusList: state => state.customMessagesStatusList,
    mnMessagesStatusList: state => state.mnMessagesStatusList,
    priorityList:state => state.priorityList,
    originatorStatusList:state => state.originatorStatusList,
    smsFilterConditionsList:state => state.smsFilterConditionsList,
    delimiterList:state => state.delimiterList,
    restrictionsList:state => state.restrictionsList,
    devicesList:state => state.devicesList,
};